import * as React from 'react';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import CollaboratorPersona from '../Collaborator/CollaboratorPersona';
import { useTranslation } from 'react-i18next';
import { DocumentUploadControlSaved } from '../../system/documents/DocumentUploadControl';
interface DocumentControlListItemProps {
  docControl: DocumentUploadControlSaved;
  onAssign: (docControl: DocumentUploadControlSaved) => void;
}

const DocumentControlListItem: React.FC<DocumentControlListItemProps> = ({ docControl, onAssign }) => {
  const { t } = useTranslation();

  return (
    <div>
      <hr />
      <div className="document-control-item-container">
        <div>
          <div>
            <b>{t('Concepto')}:</b> {docControl.getConcept()}
          </div>
          <div>
            <b>{t('Fecha límite')}:</b> {docControl.getLimitDate().toFormat('dd/LL/yyyy')}
          </div>
          <div>
            <b>{t('Tipo')}:</b> {docControl.getDocumentType().getName()}
          </div>
          <div style={{ marginTop: 8 }}>
            <CollaboratorPersona collaborator={docControl.getCollaborator()} />
          </div>
        </div>
        <div style={{ width: 'fit-content', marginLeft: 'auto' }}>
          <PrimaryButton text={t('Asignar')} onClick={() => onAssign(docControl)} iconProps={{ iconName: 'TextDocument' }} />
        </div>
      </div>
    </div>
  );
};

export default DocumentControlListItem;
